export type SiteLang = 'fr' | 'en' | 'es';

export const siteLangs: SiteLang[] = ['en', 'fr', 'es'];

export const isSiteLang = (value: string | null | undefined): value is SiteLang =>
    siteLangs.includes(value as SiteLang);

export const TranslateRoutes = (forcedLang?: string) => {
    const lang = forcedLang ?? localStorage.getItem("lang");
    return {
        home: lang === 'fr' ? 'accueil' : lang === 'es' ? 'inicio' : 'home',
        solution: lang === 'fr' ? 'solution' : lang === 'es' ? 'solucion' : 'solution',
        societe: lang === 'fr' ? 'societe' : lang === 'es' ? 'empresa' : 'company',
        medias: lang === 'fr' ? 'medias' : lang === 'es' ? 'medios' : 'medias',
        contact: lang === 'fr' ? 'contact' : lang === 'es' ? 'contacto' : 'contact',
        expertise: lang === 'fr' ? 'expertises' : lang === 'es' ? 'saber-hacer' : 'expertises',
        valence: lang === 'fr' ? 'expertises/valence' : lang === 'es' ? 'saber-hacer/valence' : 'expertises/valence',
        reunion: lang === 'fr' ? 'expertises/reunion' : lang === 'es' ? 'saber-hacer/reunion' : 'expertises/reunion',
        carjaune: lang === 'fr' ? 'expertises/carjaune' : lang === 'es' ? 'saber-hacer/carjaune' : 'expertises/carjaune',
        avignon: lang === 'fr' ? 'expertises/avignon' : lang === 'es' ? 'saber-hacer/avignon' : 'expertises/avignon',
        douai: lang === 'fr' ? 'expertises/douai' : lang === 'es' ? 'saber-hacer/douai' : 'expertises/douai',
        rouen: lang === 'fr' ? 'expertises/rouen' : lang === 'es' ? 'saber-hacer/rouen' : 'expertises/rouen',
        cookie: lang === 'fr' ? 'cookie' : lang === 'es' ? 'cookie' : 'cookie',
        legal: lang === 'fr' ? 'legal' : lang === 'es' ? 'legal' : 'legal',
        team: lang === 'fr' ? 'equipe' : lang === 'es' ? 'equipo' : 'team',
        events: lang === 'fr' ? 'evenements' : lang === 'es' ? 'eventio' : 'events',
        privacy: lang === 'fr' ? 'privee' : lang === 'es' ? 'privacidad' : 'privacy',
        eventsxmedias: lang === 'fr' ? 'a-la-une' : lang === 'es' ? 'en-primera-plana' : 'headlines',
    };
};

/**
 * Traduit la partie du chemin située après la langue (ex. "evenements/3017")
 * d'une langue vers une autre (ex. "events/3017"). Les segments inconnus sont conservés.
 */
export const translateTail = (tail: string[], from: SiteLang, to: SiteLang): string[] => {
    const src = Object.values(TranslateRoutes(from));
    const dst = Object.values(TranslateRoutes(to));

    // Correspondance la plus longue d'abord : "expertises/valence" avant "expertises"
    let bestLength = 0;
    let bestTarget: string[] = [];
    src.forEach((route, i) => {
        const parts = route.split('/');
        if (parts.length > bestLength && parts.length <= tail.length && parts.every((p, k) => p === tail[k])) {
            bestLength = parts.length;
            bestTarget = dst[i].split('/');
        }
    });

    return bestLength === 0 ? tail : [...bestTarget, ...tail.slice(bestLength)];
};
